import { Component } from '@angular/core';
import { SvgIconComponent } from '../../../services/svg-service/svg-icon/svg-icon';
import { MsaadaAi } from './msaada-ai/msaada-ai';
import { ClickOutsideDirective } from '../../directives/click-outside';
import { ChatCenter } from './chat-center/chat-center';
import { AccessibilityComponent } from './accessibility/accessibility.component';

interface WidgetItem {
  id: 'msaadaAi' | 'chatCenter' | 'accessibility';
  label: string;
  icon: string;
  type: 'img' | 'svg';
  src?: string;
}

@Component({
  selector: 'app-accessibility-widget',
  imports: [SvgIconComponent, MsaadaAi, ClickOutsideDirective, ChatCenter, AccessibilityComponent],
  templateUrl: './accessibility-widget.html',
  styleUrl: './accessibility-widget.scss',
})
export class AccessibilityWidget {
  viewType: WidgetItem['id'] | null = null;
  isClosing = false;
  isLoading: boolean = false;

  widgets: WidgetItem[] = [
    {
      id: 'msaadaAi',
      label: 'Msaada AI',
      icon: 'hudumaAI',
      type: 'img',
      src: 'assets/accessibility/hudumaAI.png',
    },
    { id: 'chatCenter', label: 'Chat Bot', icon: 'chatbot', type: 'svg' },
    { id: 'accessibility', label: 'Accessibility', icon: 'accessibility', type: 'svg' },
  ];

  setViewType(type: WidgetItem['id']) {
    this.viewType = type;
  }

  closePanel() {
    this.viewType = null;
  }

  get activeWidget() {
    return this.widgets.find((w) => w.id === this.viewType);
  }
}
